import Vue from 'vue'
import Vuex from 'vuex'
import authentication from './modules/authentication'
import app from './modules/app'
import fichaClinica from './modules/fichaClinica'
import avaliacaoPsicossocial from './modules/avaliacaoPsicossocial'
import user from './modules/user'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ['user', 'avaliacaoPsicossocial', 'app']
})

export default new Vuex.Store({
  plugins: [vuexLocal.plugin],
  modules: {
    authentication,
    app,
    fichaClinica,
    avaliacaoPsicossocial,
    user
  }
})
